import React from 'react';
import css from  './FormError.module.css';

export const FormError = ({errorText}) => {
    return (
        <div className={css['form-error']}>{errorText}</div>
    )
}

export default FormError;